import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { API_URL } from "../../shared/constant";
import { toast } from "react-toastify";
import axios from "axios";
import Swal from "sweetalert2";
import Select from "react-select";
import Loader from "../../shared/loader";

const State = () => {
  const [stateData, setStateData] = useState([]);
  const [countryDrp, setCountryDrpData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [formdata, setFormData] = useState({
    country_id: 101,
  });

  const getCountryDrpData = () => {
    axios.post(API_URL.COUNTRY_LIST, {}).then((res) => {
      setCountryDrpData(res.data.data);
      let cd = res.data.data.map((caw) => {
        return {
          label: caw.name,
          value: caw.id,
        };
      });
      setCountryDrpData(cd);
    });
  };

  const getState = () => {
    axios.post(API_URL.STATE_LIST, { country_id: formdata.country_id }).then(
      (res) => {
        if (res.data.status === 1) {
          setStateData(res.data.data);
        }
        setLoading(false);
      },
      (error) => {
        setLoading(false);
        toast.error("Something went wrong..", {
          autoClose: 3000,
          
        });
      }
    );
  };

  const deleteState = (row) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to delete this - " + row.name,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        setLoading(true);
        axios.post(API_URL.STATE_DELETE, { id: row.id }).then(
          (res) => {
            if (res.data.status === 1) {
              let newData = stateData.filter((r) => r.id != row.id);
              setStateData(newData);
            toast.success("Delete Successfully", { autoClose: 3000 });
            } else {
                toast.error(res.data.data, { autoClose: 3000 });
            }
            setLoading(false);
          },
          (error) => {
            setLoading(false);
            toast.error("Something went wrong..", { autoClose: 3000 });
          }
        );
      }
    });
  };

  const styles = {
    menu: (baseStyles, state) => ({
      ...baseStyles,
      marginTop: 2,
      zIndex: 999,
    }),
  };

  useEffect(() => {
    getState();
  }, [formdata.country_id]);
  useEffect(() => {
    getCountryDrpData();
  }, []);
  return (
    <>
      <div className="row">
        <div className="col-4">
          <h1>
            State <small className="me-2">({stateData.length})</small>
          </h1>
        </div>
        <div className="col-8">
          <div className="d-flex align-items-center  justify-content-end">
            <div className="form-group mb-0 mr-2" style={{ width: 300 }}>
               <Select
                placeholder="Select Country"
                options={countryDrp}
                className="form-control-sm"
                style={{ border: "1px solid lightgray" }}
                value={countryDrp.find((r) => r.value == formdata.country_id)}
                styles={styles}
                onChange={(e) =>
                  setFormData({ ...formdata, country_id: e.value })
                }
              />
            </div>
            <Link to={"/state/add"} className="btn btn-primary">
              <i className="fa fa-plus-circle me-2" aria-hidden="true"></i> Add
              State
            </Link>
          </div>
        </div>
        <div className="col-sm-12">
          <div className="card">
            <div className="card-body p-0">
              {loading && <Loader></Loader>}
              {!loading && (
                <div className="table-responsive">
                  <table className="table">
                    <thead className="">
                      <tr>
                        <th>#</th>
                        <th>Name</th>
                        <th className="text-center" style={{ width: "200px" }}>
                          Actions
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {stateData.map((row, key) => {
                        return (
                          <tr key={key}>
                            <td style={{ width: "10px" }}>{key + 1}</td>
                            <td>
                              {row.name}
                            </td>
                            <td
                              className="d-flex justify-content-center gap-2"
                              style={{ width: "200px" }}
                            >
                              <Link
                                to={"/state/edit/" + row.id}
                                className="btn btn-sm btn-secondary mr-2"
                              >
                                <i className="fa fa-edit me-1"></i> Edit
                              </Link>
                              <button
                                onClick={() => deleteState(row)}
                                className="btn btn-sm btn-danger me-2"
                              >
                                <i className="fa fa-trash me-1"></i> Delete
                              </button>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default State;
